module.exports = __webpack_public_path__ + "img/Pedro-Pimentel.25a2be69.png";